export const USER_ACCESS = {
  READ: 'read',
  EDIT: 'edit',
  EDITOR: 'editor',
  DELETE: 'delete',
  OWNER: 'owner',
}
